export const TRAFFIC_LIGHT_STATUSES = {
    RED: "red",
    YELLOW: "yellow",
    GREEN: "green"
};